import { render, staticRenderFns } from "./flatChoose.vue?vue&type=template&id=be1f221c&"
import script from "./flatChoose.vue?vue&type=script&lang=js&"
export * from "./flatChoose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports